import { Box, Flex, Text } from "rebass";
import StyledTag from "../../../../Components/Common/StyledTag";
import React from "react";

const COLOR_MAPPER = {
  NO: {
    textColor: "#28B826",
    bgColor: "#EBFBEF",
  },
  LOW: {
    textColor: "#7826B8",
    bgColor: "#EAD0FF",
  },
  HIGH: {
    textColor: "#EB5764",
    bgColor: "#FBEBEB",
  },
};

const SuicidalRisk = ({ suicidalData }) => (
  <Flex
    gap={24}
    justifyContent="space-evenly"
  >
    <Flex
      flexDirection="column"
      justifyContent="space-between"
    >
      {/* Titles */}
      {["คะแนน", "ระดับ", "รายละเอียด"].map((title) => (
        <Text
          key={title}
          textAlign="start"
          color="#507FD0"
          css={{
            fontSize: 18,
            fontWeight: 700,
          }}
        >
          {title}
        </Text>
      ))}
    </Flex>

    {/* Contents */}
    <Box
      css={{
        display: "grid",
        gridRowGap: 24,
        gridTemplateColumns: "repeat(8, 56px)",
        gridTemplateRows: "repeat(3, auto)",
        alignItems: "center",
      }}
    >
      {/* Score */}
      {Array(8)
        .fill()
        .map((_, i) => (
          <React.Fragment key={i}>
            <StyledTag
              bgColor={COLOR_MAPPER[suicidalData?.level]?.bgColor}
              highlighted={suicidalData?.score === i}
              textColor={COLOR_MAPPER[suicidalData?.level]?.textColor}
              title={i}
              isDisabled={!suicidalData}
            />
          </React.Fragment>
        ))}

      {/* Level */}
      {/* Level NO */}
      <Flex
        css={{
          gridColumnStart: 1,
          gridColumnEnd: 2,
        }}
      >
        <StyledTag
          bgColor={COLOR_MAPPER[suicidalData?.level]?.bgColor}
          highlighted={suicidalData?.level === "NO"}
          textColor={COLOR_MAPPER[suicidalData?.level]?.textColor}
          title="ไม่มี"
          isDisabled={!suicidalData}
        />
      </Flex>
      {/* Level LOW */}
      <Flex
        css={{
          gridColumnStart: 2,
          gridColumnEnd: 6,
        }}
      >
        <StyledTag
          bgColor={COLOR_MAPPER[suicidalData?.level]?.bgColor}
          highlighted={suicidalData?.level === "LOW"}
          textColor={COLOR_MAPPER[suicidalData?.level]?.textColor}
          title="ต่ำ"
          isDisabled={!suicidalData}
        />
      </Flex>
      {/* Level HIGH */}
      <Flex
        css={{
          gridColumnStart: 6,
          gridColumnEnd: 9,
        }}
      >
        <StyledTag
          bgColor={COLOR_MAPPER[suicidalData?.level]?.bgColor}
          highlighted={suicidalData?.level === "HIGH"}
          textColor={COLOR_MAPPER[suicidalData?.level]?.textColor}
          title="สูง"
          isDisabled={!suicidalData}
        />
      </Flex>

      {/* Detail */}
      <Flex
        css={{
          gridColumnStart: 1,
          gridColumnEnd: 10,
        }}
      >
        <StyledTag
          bgColor={suicidalData ? "#E2F6FE" : "#E8E8E8"}
          highlighted={true}
          textColor="#153962"
          title={suicidalData ? suicidalData?.detail : "ไม่พบข้อมูล"}
        />
      </Flex>
    </Box>
  </Flex>
);

export default SuicidalRisk;
